import { loginWidget } from "./login";
import { productPurchaseWidget } from "./product";
import { addCartCountListener, basketWidget } from "./basket";
import { membershipPurchaseWidget } from "./membership";

import {
  eventPurchaseWidget,
  checkoutWidget,
  expressCheckoutWidget,
} from "./checkout";

import { calendarWidget, mountCalendarWidget } from "./calendar";

export {
  membershipPurchaseWidget,
  eventPurchaseWidget,
  productPurchaseWidget,
  basketWidget,
  basketWidget as shoppingCartWidget,
  checkoutWidget,
  expressCheckoutWidget,
  loginWidget,
  addCartCountListener,
  calendarWidget,
  mountCalendarWidget,
};
